import { render } from "./SvgBase.vue?vue&type=template&id=06667d8d"
import script from "./SvgBase.vue?vue&type=script&lang=ts"
export * from "./SvgBase.vue?vue&type=script&lang=ts"
script.render = render

export default script